import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || process.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || process.env.VITE_SUPABASE_ANON_KEY;

// Validação: evita erro silencioso se esquecer de setar variáveis
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('⛔ Erro de Configuração');
  console.error('VITE_SUPABASE_URL:', supabaseUrl ? 'definido' : 'NÃO definido');
  console.error('VITE_SUPABASE_ANON_KEY:', supabaseAnonKey ? 'definido' : 'NÃO definido');
  throw new Error('⛔ Supabase URL ou Anon Key não definidos. Verifique as variáveis de ambiente no painel de deploy.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    headers: {
      'apikey': supabaseAnonKey,
    },
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});
